module.exports = __webpack_public_path__ + "img/icon_arrow02.a8497fb7.svg";